import { useEffect, useCallback, useState } from 'react';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import { getPaymentStatus } from 'services/ApiService';
import Layout from 'components/pageLayout/Layout';
import DefaultHeader from 'components/pageLayout/DefaultHeader';
import PageContentContainer from 'components/pageLayout/PageContentContainer';
import Button from 'components/Button';
import Spinner from 'components/Spinner';
import { BUTTON_TYPE_LINK } from 'shared/constants/common';

export default function PaymentStatusPageNoSession() {
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState('');

  const getParamFromUrl = (param) => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(param);
  };

  const setPaymentMessage = useCallback(({ data: { paymentStatus: status } = {} }) => {
    switch (status) {
      case 'successful':
        setMessage('Thank you, your payment was successful!');
        break;
      case 'pending':
        setMessage('Your payment is pending. Please contact your bank for further information.');
        break;
      case 'failed':
        setMessage('Sorry, your payment was unsuccessful!');
        break;
      case 'aborted':
        setMessage('Payment cancelled.');
        break;
      default:
        setMessage('Payment status unknown.');
    }
  }, []);

  const loadPaymentStatus = useCallback(async (transactionGuid) => {
    try {
      const data = await getPaymentStatus(transactionGuid);
      setPaymentMessage(data);
    } catch (error) {
      console.error(error);
      setMessage('Payment status unknown.');
    } finally {
      setIsLoading(false);
    }
  }, [setPaymentMessage]);

  useEffect(() => {
    const transactionGuid = getParamFromUrl('transactionGuid');
    if (transactionGuid) {
      loadPaymentStatus(transactionGuid);
    } else {
      setIsLoading(false);
      setMessage('No transaction specified.');
    }
  }, [loadPaymentStatus]);

  return (
    <Layout>
      <DefaultHeader label="Payment status" homeLink={ROUTES_SELF_SERVICE.LOGIN} />
      <PageContentContainer className='flex-1'>
        <div className='flex items-start pt-6 pb-6 min-h-[calc(100vh-26.5rem)]'>
          {isLoading ? (
            <Spinner className='flex flex-col pt-6 pb-6 w-full md:w-9/12 m-h-[150px]'/>
          ) : (
            <div className='flex flex-col pt-6 pb-6 w-full md:w-9/12'>
              <h1 className='ml-[20px] mt-6 text-3xl font-medium'>{message}</h1>

              <p className='ml-[20px] mt-4 p-2 text-gray-500'>
                You are not signed in on this browser. You will need to log in to view your up to date booking.
              </p>

              <Button
                className='ml-[20px] my-6 mr-[20px] w-[200px]'
                label='Login'
                type={BUTTON_TYPE_LINK}
                url={ROUTES_SELF_SERVICE.LOGIN}
              />
            </div>
          )}
        </div>
      </PageContentContainer>
    </Layout>
  );
}
